import * as React from "react";
import { Item } from '../../types/Item';
import { Store } from "dw_azsearchstore";
import { Collapse } from "reactstrap";
import { Translation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

import './Sortbox.scss'
import { PropsType } from "../../containers/SortboxContainer";

export type State = {
    isOpen: boolean;
    isMobile: boolean;
    enableCollapse: boolean;
    selectedSortKey: string;
    selectedSortOrder: string;
};

class Sortbox extends React.Component<PropsType, State> {

    constructor(props: PropsType) {
        super(props);

        let isMobile = this.isMobile();
        this.state = {
            isOpen: !isMobile,
            isMobile: isMobile,
            enableCollapse: false,
            selectedSortKey: "CreatedOn",
            selectedSortOrder: "desc"
        };

        this.updateState = this.updateState.bind(this);
        this.toggleIsOpen = this.toggleIsOpen.bind(this);
        window.addEventListener('resize', this.updateState);
    }

    isMobile() {
        return window.innerWidth <= 768;
    }

    updateState() {
        let isMobile = this.isMobile();
        this.setState({
            isOpen: !isMobile,
            isMobile: isMobile
        });
    }

    toggleIsOpen() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    /**
     * Adds the selected sort to the selected sort state properties and updates the query to order by the selected sort
     * @param sorterKey Sorter key
     * @param sorterOrder Sorter order
     */
    addSorter = (sorterKey: string, sorterOrder: string) => {
        this.setState({
            selectedSortKey: sorterKey,
            selectedSortOrder: sorterOrder
        });
        console.log(this.state);

        if (sorterKey === "Relevance")
            this.props.removeSorter();
        else
            this.props.addSorter(sorterKey, sorterOrder);

        // this event is important for the easterEgg
        document.dispatchEvent(new CustomEvent("sorterAdded",
            {
                detail: {
                    sorterKey: sorterKey,
                    sorterOrder: sorterOrder
                }
            }));
    }

    /**
     * Generates an <a> element for the defined sorter
     * @param sorterKey Sorter key
     * @param sorterOrder Sorter order
     * @param text Sorter text to be displayed in the <a> element
     */
    getLinkElement(sorterKey: string, sorterOrder: string, text: string) {
        let className = (this.state.selectedSortKey === sorterKey && this.state.selectedSortOrder === sorterOrder) ? "active" : "";
        let onClick = () => this.addSorter(sorterKey, sorterOrder);

        return <a className={className} onClick={onClick}><Translation>{t => t(text)}</Translation></a>
    }

    render() {
        const { results, total } = this.props;
        let { isMobile, isOpen, enableCollapse } = this.state;

        const toggleIsOpen = enableCollapse && isMobile ? this.toggleIsOpen : undefined;
        const caret = (isMobile) ?
            <span className="caret">
                <FontAwesomeIcon icon={isOpen ? faAngleUp : faAngleDown} />
            </span>
            : null;

        return (
            <div className="results-header">
                <span className="results-header-text"><Translation>{t => t("{{count}} from {{total}} result", { count: results.length, total: total })}</Translation></span>
                <span className="results-header-sort">
                    <span className="results-header-sort-label" onClick={toggleIsOpen}>
                        <Translation>{t => t("Sort by") + (!isMobile ? ":" : "")}</Translation>
                        {(enableCollapse) ? caret : null}
                    </span>
                    <Collapse className="results-header-sort-options" isOpen={!enableCollapse || (enableCollapse && isOpen)}>
                        {this.getLinkElement("CreatedOn", "desc", "New to old")}
                        {this.getLinkElement("CreatedOn", "asc", "Old to new")}
                    </Collapse>
                </span>
            </div>
        );
    }
}

export default Sortbox;


